class BlockFAQ {
	constructor(blockFAQEl) {
		this.el = blockFAQEl;
		this.init();
	}

	init() {
		this.el.querySelectorAll('.block-faq__section').forEach((section) => {
			const question = section.querySelector('.block-faq__question-container');
			const content = section.querySelector('.block-faq__content');

			if (!question || !content) {
				return;
			}

			// Set the initial height for FAQs that are open by default.
			if (content.classList.contains('open')) {
				content.style.maxHeight = `${content.scrollHeight}px`;
			} else {
				content.style.maxHeight = '0px';
			}

			question.addEventListener('click', () => {
				const isOpen = question.classList.contains('open');

				question.classList.toggle('open', !isOpen);
				content.classList.toggle('open', !isOpen);

				// Use the content's actual height to animate the accordion.
				if (isOpen) {
					content.style.maxHeight = '0px';
				} else {
					content.style.maxHeight = `${content.scrollHeight}px`;
				}
			});
		});
	}
}

export default BlockFAQ;